import { useApiMutation } from '../../queries/useApiMutation';
import { queryKeys } from '../../queries/queryKeys';
import { setQueryDataSafe } from '../../utils/queryUtilities';
import { post } from '../../queries';

export const useAddFavouriteEventMutation = () => {
    const mutation = useApiMutation<{ userId: string; eventId: string }>({
        mutationFn: ({ userId, eventId }) => post(`users/${userId}/favourites/${eventId}`, {}),
        onManualCacheUpdate: (queryClient, _response, args) => {
            setQueryDataSafe<string[]>(queryClient, queryKeys.users.favourites(args.userId), (previous) =>
                previous.includes(args.eventId) ? previous : [...previous, args.eventId]
            );
        },
    });

    return mutation;
};
